import { render, staticRenderFns } from "./BeefTagsModal.vue?vue&type=template&id=48638ada"
import script from "./BeefTagsModal.vue?vue&type=script&lang=js"
export * from "./BeefTagsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports